import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/spot/usage")({ beforeLoad: ({ params }) => { throw redirect({ href: `/${encodeURIComponent(params.org)}/billing/usage?instances=true`, replace: true }); } });
